module.exports = __webpack_public_path__ + "img/image-5.dea0e925.svg";